import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import i18next from 'i18next';

import {
  SearchAllMembers,
  PageHeader,
  Breadcrumbs,
} from '../../components';

import {
  APP_OPTIONS,
} from '../../config/constants';

import './style.scss';

const SearchMembers = () => {
  const classes = classNames('SearchMembers');
  const sortOptionTitle = `${APP_OPTIONS.parameters.searchkitIndexAllMembers}_title`;
  const sortOptionScore = APP_OPTIONS.parameters.searchkitIndexAllMembers;

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Helmet>
        <title>{i18next.t('our_members')}</title>
      </Helmet>
      <SearchAllMembers>
        <PageHeader>
          <div>
            <Breadcrumbs overrideUrl="/" overrideTitle="Onze leden" />
          </div>
          <h1 className="PageHeader__title">{i18next.t('our_members')}</h1>
          <div className="SearchMembers__filters">
            <div className="row">
              <div className="col-12 col-lg-5">
                <div className="SearchMembers__searchbar__wrapper">
                  <label htmlFor="query">
                    {i18next.t('components.search.searchbar.title')}
                  </label>
                  <div className="SearchMembers__searchbar">
                    <div className="SearchMembers__searchbar__icon">
                      <i className="icon icon-search" />
                    </div>
                    <SearchAllMembers.SearchBar
                      defaultSorting={sortOptionTitle}
                      relevanceSorting={sortOptionScore}
                      typeMembers
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-7">
                <SearchAllMembers.SearchFacets />
              </div>
            </div>
          </div>
        </PageHeader>
        <div className="SearchMembers__results">
          <SearchAllMembers.SearchResults />
        </div>
        <div className="SearchMembers__pagination">
          <SearchAllMembers.SearchPagination
            previousLabel={i18next.t('prev')}
            nextLabel={i18next.t('next')}
          />
        </div>
      </SearchAllMembers>
    </article>
  );
};

export default SearchMembers;
